import memoize from 'lodash.memoize';
import namedRegexp from 'named-js-regexp';

declare const window: any;

const PIXEL_RATIO =
  typeof window !== 'undefined'
    ? Math.round(Math.min(window.devicePixelRatio || 1, 3))
    : 1;

function utf8_encode(argString) {
  // http://kevin.vanzonneveld.net
  // +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +   improved by: sowberry
  // +    tweaked by: Jack
  // +   bugfixed by: Onno Marsman
  // +   improved by: Yves Sucaet
  // +   bugfixed by: Onno Marsman
  // +   bugfixed by: Ulrich
  // +   bugfixed by: Rafal Kukawski
  // +   improved by: kirilloid
  // *     example 1: utf8_encode('Kevin van Zonneveld');
  // *     returns 1: 'Kevin van Zonneveld'

  if (argString === null || typeof argString === 'undefined') {
    return '';
  }

  const string = argString + ''; // .replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  let utftext = '';
  let start = 0;
  let end = 0;
  let stringl = 0;

  start = end = 0;
  stringl = string.length;
  for (let n = 0; n < stringl; n++) {
    const c1 = string.charCodeAt(n);
    let enc: string | null = null;

    if (c1 < 128) {
      end++;
    } else if (c1 > 127 && c1 < 2048) {
      enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
    } else {
      enc = String.fromCharCode(
        (c1 >> 12) | 224,
        ((c1 >> 6) & 63) | 128,
        (c1 & 63) | 128,
      );
    }
    if (enc !== null) {
      if (end > start) {
        utftext += string.slice(start, end);
      }
      utftext += enc;
      start = end = n + 1;
    }
  }

  if (end > start) {
    utftext += string.slice(start, stringl);
  }

  return utftext;
}

function crc32(str) {
  // http://kevin.vanzonneveld.net
  // +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
  // +   improved by: T0bsn
  // +   improved by: http://stackoverflow.com/questions/2647935/javascript-crc32-function-and-php-crc32-not-matching
  // -    depends on: utf8_encode
  // *     example 1: crc32('Kevin van Zonneveld');
  // *     returns 1: 1249991249
  str = utf8_encode(str);
  const table =
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

  let crc = 0;
  let x: any = 0;
  let y: any = 0;

  crc = crc ^ -1;
  for (let i = 0, iTop = str.length; i < iTop; i++) {
    y = (crc ^ str.charCodeAt(i)) & 0xff;
    x = '0x' + table.substr(y * 9, 8);
    crc = (crc >>> 8) ^ x;
  }

  crc = crc ^ -1;

  //convert to unsigned 32-bit int if needed
  if (crc < 0) {
    crc += 4294967296;
  }
  return crc;
}

const makeOptions = function (options) {
  if (!options.gravity && !options.crop) {
    options.gravity = 'auto';
  }
  if (!options.crop) {
    options.crop = 'fill';
  }
  if (!options.flags) {
    options.flags = 'progressive';
  }
  if (options.screenwidth === true && typeof window !== 'undefined') {
    options.width = Math.round(window.innerWidth);
  }
  if (options.screenheight === true && typeof window !== 'undefined') {
    options.height = Math.round(window.innerHeight);
  }

  // prevent generating file:// urls on cordova
  if (!options.protocol) {
    options.protocol = 'https://';
  }

  //if(options.opacity){
  //    options.fetch_format = "png"
  //}
  // if (options.fetch_format == null){
  //     options.fetch_format = "jpg"
  // }

  if (options.dpr) {
    if (typeof options.dpr === 'string') {
      options.dpr = parseFloat(options.dpr);
    }
    options.dpr = Math.round(options.dpr);
    if (options.dpr > 3) {
      options.dpr = 3;
    }
  } else {
    options.dpr = PIXEL_RATIO;
  }

  if (!options.quality) {
    options.quality = 'auto';
  }

  return { ...options };
};

const gcd = function (a, b) {
  if (b > a) {
    return gcd(b, a);
  }
  if (b === a) {
    return a;
  }
  if (b === 0) {
    return a;
  } else {
    return gcd(b, a % b);
  }
};

const aspectRatio = memoize(
  function (width, height) {
    const g = gcd(
      Math.round(parseFloat(width)),
      Math.round(parseFloat(height)),
    );
    return [Math.round(width / g), Math.round(height / g)];
  },
  (w, h) => `gcd(${w},${h})`,
);

const buildUrl = function (options, cloud_name, id) {
  const transformations: string[] = [];
  const transformations2: string[] = [];

  if (options.responsive) {
    const breakpoints =
      options.responsive === true ? '100' : options.responsive;
    if (options.width && options.height) {
      const ratio = aspectRatio(options.width, options.height);
      transformations.push(`ar_${ratio[0]}:${ratio[1]}`);
      transformations2.push(
        `w_auto:${breakpoints}:${Math.round(parseFloat(options.width))}`,
      );
    } else if (options.width) {
      transformations2.push(
        `w_auto:${breakpoints}:${Math.round(parseFloat(options.width))}`,
      );
    } else {
      //height only is just not going to work
      transformations.push('h_' + Math.round(parseFloat(options.height)));
    }
  } else {
    if (options.width) {
      transformations.push('w_' + Math.round(parseFloat(options.width)));
    }
    if (options.height) {
      transformations.push('h_' + Math.round(parseFloat(options.height)));
    }
  }

  if (options.hflip) {
    transformations.push('a_hflip');
  }
  if (options.crop) {
    transformations.push('c_' + options.crop);
  }
  if (options.zoom) {
    transformations.push('z_' + options.zoom);
  }
  if (options.gravity) {
    transformations.push('g_' + options.gravity);
  }
  if (options.gravity2) {
    transformations.push('g_' + options.gravity2);
  }
  if (options.radius) {
    transformations.push('r_' + options.radius);
  }
  if (options.quality) {
    transformations.push('q_' + options.quality);
  }
  if (options.dpr) {
    if (options.dpr === 'auto') {
      // do nothing, dpr auto breaks on devices that have a dpr with 3 or higher
    } else {
      transformations.push('dpr_' + options.dpr + '.0');
    }
  }
  if (options.x) {
    transformations.push('x_' + options.x);
  }
  if (options.y) {
    transformations.push('y_' + options.x);
  }
  if (options.opacity) {
    transformations.push('o_' + options.opacity);
  }
  if (options.border) {
    transformations.push('bo_' + options.border.replace(/#/g, '%23'));
  }
  if (options.background) {
    transformations.push('b_' + options.background);
  }
  if (options.e) {
    transformations.push('e_' + options.blur);
  }
  if (options.brightness) {
    transformations.push('e_brightness:' + options.brightness);
  }
  if (options.saturation) {
    transformations.push('e_saturation:' + options.saturation);
  }
  if (options.raw) {
    transformations.push(options.raw);
  }
  if (options.fetch_format === 'jpg') {
    transformations.push('fl_progressive');
  } else {
    transformations.push('f_auto');
  }

  const transformationPart = transformations.join();
  const transformationPart2 =
    transformations2.length > 0 ? '/' + transformations2.join() : '';

  let subdomain = 'res';
  let baseUrl = options.protocol + subdomain + '.cloudinary.com/' + cloud_name;
  if (options.cdn_load_balance === true) {
    //provide a repeatable subdomain cdn to speed up downloading images
    const subcdn = (crc32(id) % 5) + 1;
    subdomain = 'res-' + subcdn;
  }
  if (options.private_cdn === true) {
    baseUrl = options.protocol + cloud_name + '-res.cloudinary.com';
  }

  let url =
    baseUrl +
    '/image/upload/' +
    transformationPart +
    transformationPart2 +
    '/' +
    id;
  if (!!options.fetch_format) {
    url = url + '.' + options.fetch_format;
  }
  return url;
};
// see https://regex101.com/r/iS5oQ8/1 for testing
const terribleRegex = namedRegexp(
  '^(?:https?:)?(?://)?' +
    '(?:(?<name>[a-zA-Z-]+)-res.cloudinary.com|res.cloudinary.com/(?<name>[a-zA-Z-]+)?)' +
    '/image/upload/' +
    '(?:(?:v[a-zA-Z0-9]+|(?:[a-z]+_[a-z0-9.]+,?)+)/)?' +
    '(?<id>[%a-zA-Z_0-9-/.]+)$',
);

//^https?://(withlocals)-com-res.cloudinary.com/image/upload/[a-zA-Z0-9\.,_]*/([a-zA-Z_0-9\/-]*)(.jpg|.png)?$

const getTerribleRegexMatch = memoize((url: string) => {
  let pattern = url;
  // cut out file extension
  if (pattern.endsWith('.jpg') || pattern.endsWith('.png')) {
    pattern = pattern.substr(0, pattern.length - 4);
  }
  return terribleRegex.exec(pattern);
});

export function createCloudinaryUrl(
  url: string | null | undefined,
  options: any,
  failIfUnableToParse?: any,
) {
  let match;
  try {
    if (
      options &&
      url !== null &&
      typeof url === 'string' &&
      (match = getTerribleRegexMatch(url))
    ) {
      const groups = match.groups();
      const cloud_name = groups.name;
      const id = groups.id;
      if (cloud_name !== null && id !== null) {
        const extendedOptions = { ...options };
        if (typeof window !== 'undefined' && window.cloudinary_config) {
          for (const k in window.cloudinary_config) {
            if (typeof extendedOptions[k] === 'undefined') {
              extendedOptions[k] = window.cloudinary_config[k];
            }
          }
        }

        const urlOptions = makeOptions(extendedOptions);
        return buildUrl(urlOptions, cloud_name, id);
      } else {
        if (failIfUnableToParse) {
          throw Error('unable to find cloud_name and id from input');
        } else {
          return url;
        }
      }
    } else {
      if (failIfUnableToParse) {
        throw Error('unable to match input url :' + url);
      } else {
        return url;
      }
    }
  } catch (_error) {
    console.log(_error);
    if (failIfUnableToParse) {
      throw _error;
    } else {
      return url;
    }
  }
}

export default {
  createCloudinaryUrl: createCloudinaryUrl,
};
